import { render, staticRenderFns } from "./ReservationAccommodationSetup.vue?vue&type=template&id=75741673&scoped=true&"
import script from "./ReservationAccommodationSetup.vue?vue&type=script&lang=js&"
export * from "./ReservationAccommodationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75741673",
  null
  
)

export default component.exports